// extracted by mini-css-extract-plugin
var _1 = "giftCardSelector_boxesQuantityContainer__V7g8z";
var _2 = "giftCardSelector_container__3V1-J";
var _3 = "giftCardSelector_item__yhvpZ";
var _4 = "giftCardSelector_itemContainer__deJvQ";
var _5 = "giftCardSelector_selected__FVhkv";
export { _1 as "boxesQuantityContainer", _2 as "container", _3 as "item", _4 as "itemContainer", _5 as "selected" }
